import * as React from 'react'
import config from 'config'
import { getChannel } from 'utils/channel'
import { push } from 'features/tracking/datalayer'
import { newsletterRegistered } from './events'

type FetchOptions = {
  method: 'POST' | 'GET' | 'PUT' | 'DELETE'
  body: string
}
type Result = {
  mode:
    | 'MAIL_TRIGGER'
    | 'NO_MAIL_TRIGGER'
    | 'ALREADY_OPTIN'
    | 'NO_NEWSLETTER_REGISTRATION'
    | string
  status: 'success' | 'failure' | string
}
export default function useRaffle(props: {
  raffleId: string
  acceptNewsletterText: string
  newsletterRequired: boolean
}) {
  const [isLoading, setIsLoading] = React.useState(false)
  const [error, setError] = React.useState<null | string>(null)
  const [isFetching, setIsFetching] = React.useState<boolean>(false)
  const [email, setEmail] = React.useState<string>('')
  const [emailError, setEmailError] = React.useState<string>('')
  const [conditionsError, setConditionsError] = React.useState<boolean>(false)
  const [newsletterError, setNewsletterError] = React.useState<boolean>(false)
  const [firstName, setFirstName] = React.useState<string>('')
  const [lastName, setLastName] = React.useState<string>('')
  const [phoneNumber, setPhoneNumber] = React.useState<string>('')
  const [showCompletionPage, setShowCompletionPage] = React.useState<
    '' | 'success' | 'failure'
  >('')
  const [completionPageMode, setCompletionPageMode] = React.useState<string>('')

  const [acceptNewsletter, setAcceptNewsletter] = React.useState<boolean>(false)
  const [acceptCondition, setAcceptCondition] = React.useState<boolean>(false)
  const fetchUrl =
    'https://functions.lusini.com/.netlify/functions/POST-raffle-registration'

  const fetchOptions: FetchOptions = {
    method: 'POST',
    body: JSON.stringify({
      email: email,
      firstName: firstName,
      lastName: lastName,
      phoneNumber: phoneNumber,
      location: config.locale,
      channel: getChannel(),
      raffleId: props.raffleId,
      signInToNewsletter: props.acceptNewsletterText ? acceptNewsletter : false
    })
  }
  /** @firescoutMockFn raffle-api.fetch */
  const fetchData = async (): Promise<Result | null> => {
    setIsLoading(true)
    try {
      const jsonData = await fetch(fetchUrl, fetchOptions)
      const json = await jsonData.json()
      setIsLoading(false)
      return json
    } catch (error: any) {
      setError(error)
      setIsLoading(false)
      return null
    }
  }
  const onSubmit = async (e) => {
    e.preventDefault()
    setEmailError('')
    setConditionsError(false)
    setNewsletterError(false)

    // check if available checkboxes are checked
    const validEmail = email && email.match(/\S+@\S+\.\S+/)
    const valid =
      (props.newsletterRequired && props.acceptNewsletterText.length > 0
        ? acceptNewsletter
        : true) &&
      acceptCondition &&
      validEmail

    if (!valid) {
      if (!validEmail) {
        setEmailError(' ')
      }
      if (!acceptCondition) {
        setConditionsError(true)
      }
      if (
        props.newsletterRequired &&
        props.acceptNewsletterText.length > 0 &&
        !acceptNewsletter
      ) {
        setNewsletterError(true)
      }
    } else {
      setIsFetching(true)
      try {
        const result = await fetchData()
        setIsFetching(false)
        if (result?.status === 'success') {
          setShowCompletionPage('success')
          setCompletionPageMode(result.mode)
          newsletterRegistered(email, result.mode)
        }
        if (result?.status === 'failure') {
          setShowCompletionPage('failure')
        }
      } catch {
        setShowCompletionPage('failure')
        setIsFetching(false)
      }
    }
  }
  return {
    isLoading,
    error,
    showCompletionPage,
    email,
    emailError,
    conditionsError,
    newsletterError,
    firstName,
    lastName,
    phoneNumber,
    isFetching,
    completionPageMode,
    acceptCondition,
    acceptNewsletter,
    fetchData,
    setEmail,
    setIsFetching,
    setEmailError,
    setConditionsError,
    setNewsletterError,
    onSubmit,
    setShowCompletionPage,
    setCompletionPageMode,
    setFirstName,
    setLastName,
    setPhoneNumber,
    setAcceptNewsletter,
    setAcceptCondition
  }
}
